var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import classNames from "classnames";
import { merge } from "lodash";
import React, { Component } from "react";
import { buildThemeCssVars, THEME_DEFAULTS } from "./../../ricos-styles";
import {
  AccessibilityListener,
  getLangDir,
  GlobalContext,
  SPOILER_TYPE
} from "./../../wix-rich-content-common";
import viewerStyles from "../statics/rich-content-viewer-scss";
import rtlStyles from "../statics/rtl.rtlignore-scss";
import AddAnchors from "./components/AddAnchors";
import ContentTraverser from "./ContentTraverser";
class ContentViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "styles");
    __publicField(this, "getContextualData", ({
      t,
      theme,
      isMobile = false,
      anchorTarget,
      relValue,
      customAnchorScroll,
      config,
      locale,
      disabled,
      seoMode,
      iframeSandboxDomain,
      textAlignment,
      experiments,
      textDirection,
      direction,
      helpers,
      onNodeClick,
      jsdomMode
    }) => {
      return {
        t,
        theme: theme || {},
        isMobile,
        anchorTarget,
        relValue,
        customAnchorScroll,
        config,
        helpers: helpers || {},
        locale: locale || "en",
        disabled,
        seoMode,
        iframeSandboxDomain,
        disableRightClick: config?.uiSettings?.disableRightClick,
        textAlignment,
        experiments,
        textDirection,
        languageDir: direction || getLangDir(locale),
        onNodeClick,
        jsdomMode
      };
    });
    this.styles = { ...viewerStyles, ...rtlStyles };
  }
  render() {
    const {
      config = {},
      onHover,
      isMobile = false,
      addAnchors,
      onMouseOver = () => {
      },
      content,
      setRef,
      typeMappers,
      nodeViewRenderers,
      nodeViewDecorators,
      experiments = {},
      t
    } = this.props;
    const { styles } = this;
    const SpoilerViewerWrapper = config[SPOILER_TYPE]?.SpoilerViewerWrapper;
    const contextualData = this.getContextualData(this.props);
    const viewerClassName = classNames(styles.viewer, {
      [rtlStyles.rtl]: contextualData.textDirection === "rtl"
    });
    const themeWithDefaults = merge(
      {},
      isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop,
      contextualData.theme
    );
    const style = buildThemeCssVars(themeWithDefaults, content?.documentStyle ?? {});
    const dataId = { "data-id": "content-viewer" };
    return /* @__PURE__ */ React.createElement(GlobalContext.Provider, { key: "RicosViewer", value: { experiments, isMobile, t } }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.wrapper),
        dir: contextualData.languageDir,
        onMouseEnter: (e) => onHover && onHover(e),
        onMouseOver,
        ref: setRef,
        style,
        ...dataId
      },
      this.props.devTools,
      /* @__PURE__ */ React.createElement("div", { className: viewerClassName }, /* @__PURE__ */ React.createElement(AddAnchors, { addAnchors }, /* @__PURE__ */ React.createElement(
        ContentTraverser,
        {
          content,
          typeMappers,
          context: contextualData,
          nodeViewRenderers,
          nodeViewDecorators,
          SpoilerViewerWrapper
        }
      ))),
      /* @__PURE__ */ React.createElement(AccessibilityListener, { isMobile })
    ));
  }
}
__publicField(ContentViewer, "defaultProps", {
  theme: {},
  locale: "en",
  config: {}
});
var ContentViewer_default = ContentViewer;
export {
  ContentViewer_default as default
};
//# sourceMappingURL=ContentViewer.js.map
